import { Component } from "@angular/core";

@Component({
  selector: "app-rule-list-container-page",
  templateUrl: "./rule-list-container-page.component.html",
})
export class RuleListContainerPageComponent {}
